import { InjectionToken } from '@angular/core';

export const UserPreferencePathToken = new InjectionToken<String>(
  'user_preference_path_token'
);
